import React from 'react';
import TablaSolicitudConstancia from './Tablas/TablaSolicitudConstancia';
import GraficoSolicitudConstancia from './Graficos/GraficoSolicitudConstancia';
import SolicitudConstancia from './Ventanas/SolicitudConstancia';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasConstanciaDashboard from './Dashboard/ObrasConstanciaDashboard';

const ObrasConstancia: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Constancia
      </Heading>
      <ObrasConstanciaDashboard/>
      <TablaSolicitudConstancia />
      {/* <GraficoSolicitudConstancia /> */}
    </VStack>
  );
};

export default ObrasConstancia;
